var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_c('button',{attrs:{"type":"primary","text":"确定"},on:{"click":_vm.toScan}},[_vm._v("跳转")]),_c('div',[_c('p',[_vm._v("查询参数值: "+_vm._s(_vm.queryParam))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }